import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { TemplateCurvesPage } from "@/features/test-template/template-curves-page";

export const Route = createFileRoute("/analytics/templates/$template_id/curves")({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: template } = trpc.tests.testTemplates.getById.useQuery(template_id);
  if (!template) return null;
  return (
    <TemplateCurvesPage
      templateId={template_id}
      templateName={template.name}
      templateCode={template.code}
      isMethod={template.blueprint !== null}
    />
  );
}
